import { EnterpriseProxy, UserEnterpriseInfoViewModel } from '@/app/proxy/proxies';
import { SharedModule } from '@/app/shared/shared.module';
import { Component, OnInit } from '@angular/core';
import { ActivitiesService } from '../../activities.service';
import { filter, Observable, take } from 'rxjs';
import { Router } from '@angular/router';

interface DataViewOption {
  key: string;
  icon: string;
  label: string;
  route: string;
}

@Component({
  selector: 'app-activities-header',
  imports: [SharedModule],
  templateUrl: './activities-header.component.html',
  styleUrl: './activities-header.component.less'
})
export class ActivitiesHeaderComponent implements OnInit {
  userEnterprises$: Observable<UserEnterpriseInfoViewModel[]>;
  selectedEnterprise: UserEnterpriseInfoViewModel;
  dataViewOptions: DataViewOption[] = [
    {
      key: 'dashboard',
      icon: 'ph ph-squares-four',
      label: 'doktar_app.common.dashboard',
      route: 'dashboard'
    },
    {
      key: 'timeline',
      icon: 'ph ph-table',
      label: 'doktar_app.common.timeline',
      route: 'timeline'
    },
    {
      key: 'list',
      icon: 'ph ph-list-dashes',
      label: 'doktar_app.common.list',
      route: 'list'
    },
  ];
  selectedDataView = this.dataViewOptions[0];

  constructor(
    public activitiesService: ActivitiesService,
    private _router: Router,
    private _enterpriseProxy: EnterpriseProxy) { }

  ngOnInit(): void {
    if (this._router.url.includes('dashboard')) {
      this.selectedDataView = this.dataViewOptions.find(e => e.key === 'dashboard');
    }
    else if (this._router.url.includes('timeline')) {
      this.selectedDataView = this.dataViewOptions.find(e => e.key === 'timeline');
    }
    else if (this._router.url.includes('list')) {
      this.selectedDataView = this.dataViewOptions.find(e => e.key === 'list');
    }
    this.userEnterprises$ = this.activitiesService.userEnterprises$;
    this.activitiesService.selectedEnterprise$
      .pipe(
        filter((res) => res !== undefined && res !== null),
        take(1)
      ).subscribe(res => {
        this.onSelectEnterpriseChange(res);
      })
  }

  onSelectEnterpriseChange(event: UserEnterpriseInfoViewModel) {
    this.selectedEnterprise = event;
    this.activitiesService.setSelectedEnterprise(this.selectedEnterprise);
    
    this.getEnterpriseUsers();
  }

  getEnterpriseUsers() {
    this.activitiesService.enterpriseUsers = [];
    this._enterpriseProxy.enterprise_GetEnterpriseDetail(this.selectedEnterprise.enterpriseId)
    .pipe()
    .subscribe({
      next: res => {
        if (res.isSuccess) {
          this.activitiesService.enterpriseUsers = res.result?.members ?? []
        }
      }
    })
  }

  onDataViewChange(event: DataViewOption) {
    this._router.navigateByUrl('/activities/' + event.route);
  }
}
